"use client"

import { s as signal } from './vidstack-wClXxc1a.js';

const RemotionThumbnail = signal(
  null
);
const RemotionSliderThumbnail = signal(null);
const RemotionPoster = signal(
  null
);

export { RemotionThumbnail as R, RemotionPoster as a, RemotionSliderThumbnail as b };
